import useUser from '../../../user';

const useLogout = () => {
  const { logout } = useUser();

  const logoutUser = async () => {
    return await logout();
  };

  return {
    logoutUser
  };
};

export default useLogout;
